// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oH-z","hovered":"pH-z","hoverImage":"qH-z","mainImage":"rH-z","imageNoBackground":"sH-z","fullSizeImage":"tH-z"};